import { get } from 'lodash';
import { AppleAuthError } from 'modules/auth';

import { LOGIN, ROUTER } from 'src/constants';

import { fireToast, history, t } from 'utils';

import { authService } from 'services';

import { progressStore } from 'stores';

import { CACHE_KEYS } from '../../miles/app/home/constants/localStorageKeys';

const appleLoginAction = async (responseData, closeModal, redirectLink?: string) => {
  try {
    progressStore.log(LOGIN, 'progress');
    const errorCode = get(responseData, 'error.error');
    if (errorCode) {
      switch (errorCode) {
        case 'popup_closed_by_user':
          return;
        default:
          return fireToast(AppleAuthError(), 'error', t.staticAsString('toast.cantGetAppleUserData'), 'top-right', 0, false);
      }
    }

    const auth_code = get(responseData, 'authorization.code');
    const firstname = get(responseData, 'user.name.firstName');
    const lastname = get(responseData, 'user.name.lastName');

    const isLogged = await authService.loginApple({
      auth_code,
      firstname,
      lastname,
    });

    if (isLogged && closeModal) {
      return closeModal();
    }

    if (isLogged && !closeModal) {
      const needRedirectToMilesForm = localStorage.getItem(CACHE_KEYS.needRedirectToMilesForm);
      if (needRedirectToMilesForm) return history.push(ROUTER.MILES_SIGN_IN);
      return redirectLink ? history.push(redirectLink) : history.safeGoBack();
    }

    return fireToast(AppleAuthError(), 'error', t.staticAsString('toast.cantGetAppleUserData'), 'top-right', 0, false);
  } catch (e) {
    return fireToast(AppleAuthError(), 'error', t.staticAsString('toast.cantGetAppleUserData'), 'top-right', 0, false);
  } finally {
    progressStore.log(LOGIN, 'completed');
  }
};

const facebookLoginAction = async (token: string, closeModal, redirectLink?: string): Promise<any> => {
  progressStore.log(LOGIN, 'progress');
  const isSignUp = await authService.loginFb(token);
  progressStore.log(LOGIN, 'completed');
  handleResult(isSignUp, closeModal, redirectLink);
  return fireToast(t.staticAsString('toast.cantGetUserData'), 'error', '', 'top-right');
};

const googleLoginAction = async (token: string, closeModal, redirectLink?: string): Promise<any> => {
  progressStore.log(LOGIN, 'progress');
  const isSignUp = await authService.loginGoogle(token);
  progressStore.log(LOGIN, 'completed');
  handleResult(isSignUp, closeModal, redirectLink);
  return fireToast(t.staticAsString('toast.cantGetGoogleUserData'), 'error', '', 'top-right');
};

const handleResult = (isSignUp: boolean, closeModal: AnyFunction, redirectLink?: string) => {
  if (isSignUp && closeModal) {
    return closeModal();
  }

  if (isSignUp && !closeModal) {
    const needRedirectToMilesForm = localStorage.getItem(CACHE_KEYS.needRedirectToMilesForm);
    if (needRedirectToMilesForm) return history.push(ROUTER.MILES_SIGN_IN);
    return redirectLink ? history.push(redirectLink) : history.safeGoBack();
  }
};

export { appleLoginAction, facebookLoginAction, googleLoginAction };
